'use client';

import { IS_CLIENT } from '@repo/common-utils';
import { useEffect, useRef, useState } from 'react';

interface WindowSizeType {
  windowWidth: number;
  windowHeight: number;
}

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSizeType>({ windowHeight: 0, windowWidth: 0 });

  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (IS_CLIENT) {
      setWindowSize({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });

      const handleResize = () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(() => {
          setWindowSize({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
        }, 300);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  const isOverMobile = windowSize.windowWidth >= 480;
  const isOverTablet = windowSize.windowWidth >= 744;

  return {
    ...windowSize,
    isOverMobile,
    isOverTablet,
    timerRef
  };
};
